import firebase from "firebase";
import * as Constants from "./AppConstants";

//Development-Production

//clientLibs
import * as BPMBuildDevelopmentappspotcom from "bpmbuild_developmentappspotcom";
import * as BPMBuildProductionappspotcom from "bpmbuild_productionappspotcom";
import * as BPMBuildUatdsappspotcom from "bpmbuild_uat_dsappspotcom";

//keys
import * as developmentKeys from "../config/Files/development.json";
import * as productionKeys from "../config/Files/production.json";
import * as uatdsKeys from "../config/Files/uatds.json";

//environment
const developmentEnvironment = "DEVELOPMENT";
const productionEnvironment = "PRODUCTION";
const uatdsEnvironment = "UAT-DS";

//log levels
const developmentLogLevels = [
  Constants.LogLevel.STANDARD,
  Constants.LogLevel.WARNING,
  Constants.LogLevel.ERROR,
  Constants.LogLevel.SEVERE
];
const productionLogLevels = [];

const uatdsLogLevels = [
  Constants.LogLevel.STANDARD,
  Constants.LogLevel.WARNING,
  Constants.LogLevel.ERROR,
  Constants.LogLevel.SEVERE
];

//default
let clientLibs = BPMBuildDevelopmentappspotcom;
let keys = developmentKeys;
let environment = developmentEnvironment;
let logLevels = developmentLogLevels;

console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
  clientLibs = BPMBuildProductionappspotcom;
  keys = productionKeys;
  environment = productionEnvironment;
  logLevels = productionLogLevels;
} else if (process.env.NODE_ENV === "development") {
  if (process.env.REACT_APP_DEVTYPE === "uat-ds") {
    clientLibs = BPMBuildUatdsappspotcom;
    keys = uatdsKeys;
    environment = uatdsEnvironment;
    logLevels = uatdsLogLevels;
  } else {
    clientLibs = BPMBuildDevelopmentappspotcom;
    keys = developmentKeys;
    environment = developmentEnvironment;
    logLevels = developmentLogLevels;
  }
} else {
  clientLibs = BPMBuildDevelopmentappspotcom;
  keys = developmentKeys;
  environment = developmentEnvironment;
  logLevels = developmentLogLevels;
}

export { clientLibs as ClientLibraries, environment, logLevels };

//Standard Functions and Setup

export const getConfig = () => {
  var config = {
    apiKey: keys.firebase.apiKey,
    authDomain: keys.firebase.authDomain,
    databaseURL: keys.firebase.databaseURL,
    projectId: keys.firebase.projectId,
    storageBucket: keys.firebase.storageBucket,
    messagingSenderId: keys.firebase.messagingSenderId,
    appId: keys.firebase.appId
  };

  return config;
};

export const getApiKey = () => {
  return keys.apiKey;
};

firebase.initializeApp(getConfig());

export const getFirebaseDatabase = () => {
  return firebase.database().ref();
};

export const getFirebaseStorage = () => {
  return firebase.storage().ref();
};

export const getFirebaseAuth = () => {
  return firebase.auth;
};



// WEBPACK FOOTER //
// ./src/common/config/Configuration.js